const columns = [
  {
    name: 'house',
    label: 'Domek',
    column: 1,
    type: 'custom',
    custom: function (column, row) {
      return row.house.name;
    }
  },
  {
    label: "Powód",
    field: "title",
    width: 50,
  },
  {
    label: "Data rozpoczęcia blokady",
    field: "startDate",
    width: 60
  },
  {
    label: "Data zakończenia blokady",
    field: "endDate",
    width: 60
  }
];

export default columns;
